import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import { FiEdit2 } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function JobsApplicants() {
  const [activeTab, setActiveTab] = useState("applicants");

  /* -------------------- APPLICANTS -------------------- */
  const applicants = [
    {
      name: "Brian Villalobos",
      exp: "5+ Years",
      country: "USA",
      role: "UI/UX Designer",
      img: "/assets/img/users/user-09.jpg",
      color: "#0F4C5C",
    },
    {
      name: "Anthony Lewis",
      exp: "4+ Years",
      country: "USA",
      role: "Python Developer",
      img: "/assets/img/users/user-32-1.jpg",
      color: "#2F80ED",
    },
    {
      name: "Stephan Peralt",
      exp: "6+ Years",
      country: "USA",
      role: "Android Developer",
      img: "/assets/img/users/user-32-1.jpg",
      color: "#FF4D8D",
    },
    {
      name: "Doglas Martini",
      exp: "2+ Years",
      country: "USA",
      role: "React Developer",
      img: "/assets/img/users/user-34.jpg",
      color: "#8E44AD",
    },
  ];

  /* -------------------- OPENINGS -------------------- */
  const openings = [
    {
      title: "Senior IOS Developer",
      openings: 25,
      img: "/assets/img/icons/apple.svg",
      active: false,
    },
    {
      title: "Junior PHP Developer",
      openings: 20,
      img: "/assets/img/icons/php.svg",
      active: true,
    },
    {
      title: "Junior React Developer",
      openings: 30,
      img: "/assets/img/icons/react.svg",
      active: false,
    },
    {
      title: "Senior Laravel Developer",
      openings: 40,
      img: "/assets/img/icons/laravel.svg",
      active: false,
    },
  ];

  return (
    <>
      <Card className="jobs-card">
        {/* HEADER */}
        <div className="card-header-custom">
          <h5>Jobs Applicants</h5>
          <Link to="/jobs"  className="text-decoration-none " >
                <Button className="view-button btn btn-small border border-0">View All</Button>
    </Link>
        </div>

        <Card.Body>
          {/* TABS */}
          <div className="tabs-wrapper">
            <div
              className={`tab ${activeTab === "openings" ? "active" : ""}`}
              onClick={() => setActiveTab("openings")}
            >
              Openings
            </div>

            <div
              className={`tab ${activeTab === "applicants" ? "active" : ""}`}
              onClick={() => setActiveTab("applicants")}
            >
              Applicants
            </div>
          </div>

          {/* -------------------- OPENINGS -------------------- */}
          {activeTab === "openings" && (
            <div className="openings-list">
              {openings.map((item, i) => (
                <div className="opening-row" key={i}>
                  <div className="opening-left">
                    <div className="opening-icon">
                      <img src={item.img} alt="" />
                    </div>

                    <div>
                      <div className="opening-title">{item.title}</div>
                      <div className="opening-count">
                        No of Openings : {item.openings}
                      </div>
                    </div>
                  </div>

                  <div className={`edit-btn ${item.active ? "active" : ""}`}>
                    <FiEdit2 size={14} />
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* -------------------- APPLICANTS -------------------- */}
          {activeTab === "applicants" && (
            <div className="applicants-list">
              {applicants.map((item, i) => (
                <div className="applicant-row" key={i}>
                  <div className="applicant-left">
                    <img src={item.img} className="avatar" alt="" />

                    <div>
                      <div className="applicant-name">{item.name}</div>

                      <div className="applicant-meta">
                        Exp : {item.exp}
                        <span className="meta-dot"></span>
                        {item.country}
                      </div>
                    </div>
                  </div>

                  <span
                    className="role-badge"
                    style={{ background: item.color }}
                  >
                    {item.role}
                  </span>
                </div>
              ))}
            </div>
          )}
        </Card.Body>
      </Card>

      {/* ================= CSS ================= */}
      <style>{`
.jobs-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);
}

.card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

.view-button{
background:#f3f4f6;
border:none;
color:#111;
font-size:13px;
padding:6px 10px;
border-radius:6px;
}

.tabs-wrapper{
display:flex;
background:#f3f4f6;
border-radius:8px;
padding:4px;
margin-bottom:20px;
}

.tab{
flex:1;
text-align:center;
padding:8px 0;
font-size:14px;
font-weight:500;
cursor:pointer;
border-radius:6px;
color:#111;
}

.tab.active{
background:#FF6A00;
color:white;
}

/* OPENINGS */

.openings-list{
display:flex;
flex-direction:column;
gap:20px;
}

.opening-row{
display:flex;
justify-content:space-between;
align-items:center;
}

.opening-left{
display:flex;
align-items:center;
gap:12px;
}

.opening-icon{
width:44px;
height:44px;
background:#f3f4f6;
border-radius:8px;
display:flex;
align-items:center;
justify-content:center;
}

.opening-icon img{
width:22px;
height:22px;
object-fit:contain;
}

.opening-title{
font-weight:600;
font-size:15px;
color:#1f2937;
}

.opening-count{
font-size:13px;
color:#6b7280;
}

/* EDIT BUTTON EXACT DESIGN */

.edit-btn{
width:34px;
height:34px;
border-radius:6px;
display:flex;
align-items:center;
justify-content:center;
background:#f3f4f6;
border:1px solid #e5e7eb;
cursor:pointer;
transition:all 0.2s ease;
}

.edit-icon{
font-size:14px;
color:#6b7280;
transition:all 0.2s ease;
}

/* HOVER EFFECT */

.edit-btn:hover{
background:#FF6A00;
border-color:#FF6A00;
}

.edit-btn:hover .edit-icon{
color:#fff;
}

/* APPLICANTS */

.applicants-list{
display:flex;
flex-direction:column;
gap:22px;
}

.applicant-row{
display:flex;
justify-content:space-between;
align-items:center;
}

.applicant-left{
display:flex;
align-items:center;
gap:12px;
}

.avatar{
width:44px;
height:44px;
border-radius:50%;
object-fit:cover;
}

.applicant-name{
font-weight:600;
font-size:15px;
color:#1f2937;
}

.applicant-meta{
font-size:13px;
color:#6b7280;
display:flex;
align-items:center;
}

.meta-dot{
width:5px;
height:5px;
background:#FF6A00;
border-radius:50%;
display:inline-block;
margin:0 8px;
}

.role-badge{
color:white;
font-size:12px;
padding:5px 10px;
border-radius:6px;
font-weight:500;
white-space:nowrap;
}

@media (max-width:768px){
.applicant-row{
flex-direction:column;
align-items:flex-start;
gap:8px;
}

.role-badge{
align-self:flex-start;
}
}
`}</style>
    </>
  );
}